import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useStateContext } from '../contexts/ContextProvider';
import { BsListNested } from "react-icons/bs";
import { MdConnectWithoutContact, MdListAlt, MdOutlineCallToAction, MdOutlineClearAll, MdOutlineCloudUpload } from "react-icons/md";
import "../style/sidebar.css"
import { getLocalStorage } from '../utils/localStorage';
import { AiOutlineDatabase } from 'react-icons/ai';
import { FiUsers } from "react-icons/fi"
import { GoOrganization } from "react-icons/go";
import { MdCampaign, MdOutlineDashboard, MdMarkChatUnread, MdDashboardCustomize, MdOutlinePendingActions } from "react-icons/md"
import { RiFilePaperFill } from "react-icons/ri";
import { MdManageAccounts } from "react-icons/md";
import logo from "../data/logo/tdfLogo.png";
import gsap from 'gsap';
import SidebarPoster from "./../assets/imgs/sidebarPoster.png"
import { BiLogOutCircle } from 'react-icons/bi';
import { IoSettingsOutline } from "react-icons/io5";
import { CgProfile, CgUserList } from "react-icons/cg";
import { stopTokenRefreshWebSocket } from '../utils/useTokenRefreshWebSocket';
import { FaChevronDown, FaHotjar, FaUserPlus } from "react-icons/fa";
import { HiOutlineDocumentDuplicate } from 'react-icons/hi';

// const AccordionMenu = () => {
//   const { pathname } = useLocation();
//   // Regex pattern to extract the ID after "createOrganization/"
//   const match = pathname.match(/createOrganization\/([^/]+)/);
//   // Extracted ID
//   const organizationId = match ? match[1] : null;
//   const navigate = useNavigate();


//   const CheckPermission = () => {
//     const { role, email, orgId } = getLocalStorage("CURRENT_USER");
//     const TDFPlatformLinks = [
//       "/home/adminDashboard",
//       "/home/processRecordPlatformAllocation/tdfAdminAllocToTl",
//       "/home/teamLead/teamLeadAllocToTele",
//       "/home/teleTdfUsers",
//       "/home/userActions",
//       "/home/campaignDashboard",
//       "/home/teamLeadDashboard/platform"
//     ]
//     const links = [
//       {
//         title: 'Super Admin',
//         links: [
//           // commented because now we create same things using organization 
//           // { name: 'users', path: '/home/users', icon: <ImUsers style={{ fontSize: 14 }} />, allowed: ["ROLE_CRM_ADMIN"] },
//           // { name: 'create user', path: '/home/createuser', icon: <HiUserAdd style={{ fontSize: 14 }} />, allowed: ["ROLE_CRM_ADMIN"] },
//           // { name: 'User Info', path: '/home/userslist', icon: <HiUserAdd style={{ fontSize: 14 }} />, allowed: ["ROLE_CRM_ADMIN"] },
//           { name: 'Campaigns', path: '/home/campaign/list', icon: <MdCampaign style={{ fontSize: 14 }} />, allowed: ["ROLE_CRM_ADMIN",] },
//           { name: organizationId ? 'Update Organization' : 'Create Organization', path: '/home/createOrganization', icon: <GoOrganization style={{ fontSize: 14 }} />, allowed: ["ROLE_CRM_ADMIN"] },
//           { name: 'Organization List', path: '/home/organizationList', icon: <MdListAlt style={{ fontSize: 14 }} />, allowed: ["ROLE_CRM_ADMIN"] },


//         ],
//         Permissions: ["ROLE_CRM_ADMIN"]
//       },
//       {
//         title: 'Process Admin',
//         links: [
//           // { name: 'Dashboard', path: '/home/tdfAdminDashboard', icon: <MdOutlineDashboard />, allowed: ["ROLE_ADMIN", "ROLE_MANAGER"] },
//           // ...(email.includes("@theduefactory.com")
//           //   ? [{ name: 'Dashboard', path: '/home/adminDashboard', icon: <MdOutlineDashboard style={{ fontSize: 14 }} />, allowed: ["ROLE_ADMIN",] },]
//           //   : []), 
//           { name: 'Platform Dashboard', path: '/home/adminDashboard', icon: <MdOutlineDashboard style={{ fontSize: 14 }} />, allowed: ["ROLE_ADMIN",] }, //admin ko dikha do, tdf manager role not exit right now 
//           { name: 'Platform Allocation', path: '/home/processRecordPlatformAllocation/tdfAdminAllocToTl', icon: <FiUsers style={{ fontSize: 14 }} />, allowed: ["ROLE_ADMIN",] },
//           { name: 'Dashboard', path: '/home/analytic-dashbaord', icon: <MdDashboardCustomize style={{ fontSize: 14 }} />, allowed: ["ROLE_MANAGER", "ROLE_ADMIN"] },
//           { name: "Allocation", path: '/home/allocation/metadata', icon: <MdManageAccounts style={{ fontSize: 14 }} />, allowed: ["ROLE_ADMIN",] },

//           { name: "Campaigns", path: '/home/campaign/list', icon: <MdCampaign style={{ fontSize: 14 }} />, allowed: ["ROLE_ADMIN",] },
//           { name: 'Campaign Performance', path: '/home/campaign-Dashboard-stats', icon: <MdDashboardCustomize style={{ fontSize: 14 }} />, allowed: ["ROLE_ADMIN",] },

//           // { name: 'Client Allocation', path: '/home/processRecordAllocation/clientrecord', icon: <BsFileTextFill style={{ fontSize: 14 }} />, allowed: ["ROLE_ADMIN",] },
//           // { name: 'Platform Dashboard', path: '/home/adminDashboard', icon: <MdOutlineDashboard style={{ fontSize: 14 }} />, allowed: ["ROLE_ADMIN",] }, //admin ko dikha do, tdf manager role not exit right now 
//           { name: 'Tele Performance', path: '/home/teleperformance/attempted', icon: <RiFilePaperFill style={{ fontSize: 14 }} />, allowed: ["ROLE_ADMIN",] },

//           // { name: 'Campaigns', path: '/home/campaign/list', icon: <MdCampaign style={{ fontSize: 14 }} />, allowed: ["ROLE_ADMIN",] },
//           { name: 'Campaign Dashboard', path: '/home/campaignDashboard', icon: <MdDashboardCustomize style={{ fontSize: 14 }} />, allowed: ["ROLE_ADMIN",] },
//           // { name: "Manage Org's Users", path: '/home/addUser/list', icon: <MdManageAccounts style={{ fontSize: 14 }} />, allowed: ["ROLE_ADMIN",] },
//           // { name: 'Analytics', path: '/home/analytic-dashbaord', icon: <MdDashboardCustomize style={{ fontSize: 14 }} />, allowed: ["ROLE_ADMIN",] },

//           ...(orgId
//             ? [{ name: "Manage Org's Users", path: '/home/addUser/list', icon: <MdManageAccounts style={{ fontSize: 14 }} />, allowed: ["ROLE_ADMIN",] },]
//             : []),
//         ],
//         Permissions: ["ROLE_ADMIN",]
//       },
//       {
//         title: 'Process Manager',
//         links: [
//           // { name: 'Dashboard', path: '/home/tdfAdminDashboard', icon: <MdOutlineDashboard />, allowed: ["ROLE_ADMIN", "ROLE_MANAGER"] }, 
//           { name: 'Platform Dashboard', path: '/home/adminDashboard', icon: <MdOutlineDashboard style={{ fontSize: 14 }} />, allowed: ["ROLE_MANAGER"] },
//           { name: 'Platform Allocation', path: '/home/processRecordPlatformAllocation/tdfAdminAllocToTl', icon: <FiUsers style={{ fontSize: 14 }} />, allowed: ["ROLE_MANAGER"] },

//           { name: 'Dashboard', path: '/home/analytic-dashbaord', icon: <MdDashboardCustomize style={{ fontSize: 14 }} />, allowed: ["ROLE_MANAGER",] },

//           { name: "Allocation", path: '/home/allocation/metadata', icon: <MdManageAccounts style={{ fontSize: 14 }} />, allowed: ["ROLE_MANAGER",] },
//           {
//             name: "Campaigns",
//             path: '/home/campaign/list',
//             icon: <MdCampaign style={{ fontSize: 14 }} />,
//             allowed: ["ROLE_MANAGER",],
//             children: [
//               { name: 'All Records', path: '/home/campaign/list', icon: <MdOutlineClearAll />, allowed: ["ROLE_CRM_ADMIN", "ROLE_ADMIN", "ROLE_DS", "ROLE_MANAGER", "ROLE_TEAM_LEAD"] },
//               { name: 'Templates', path: '/home/campaign/templates', icon: <MdOutlineCloudUpload />, allowed: ["ROLE_CRM_ADMIN", "ROLE_MANAGER", "ROLE_DS", "ROLE_ADMIN"] },
//               { name: 'Hot Leads', path: '/home/campaign/allLeads', icon: <FaHotjar />, allowed: ["ROLE_MANAGER", "ROLE_TEAM_LEAD"] },
//             ]
//           },
//           { name: 'Campaign Performance', path: '/home/campaign-Dashboard-stats', icon: <MdDashboardCustomize style={{ fontSize: 14 }} />, allowed: ["ROLE_MANAGER",] },
//           { name: 'Campaign Dashboard', path: '/home/campaignDashboard', icon: <MdDashboardCustomize style={{ fontSize: 14 }} />, allowed: ["ROLE_MANAGER"] },
//           // { name: 'Client Allocation', path: '/home/processRecordAllocation/clientrecord', icon: <BsFileTextFill style={{ fontSize: 14 }} />, allowed: ["ROLE_MANAGER"] },
//           // { name: 'Campaigns', path: '/home/campaign/list', icon: <MdCampaign style={{ fontSize: 14 }} />, allowed: ["ROLE_MANAGER"] },
//           { name: 'Tele Performance', path: '/home/teleperformance/attempted', icon: <RiFilePaperFill style={{ fontSize: 14 }} />, allowed: ["ROLE_MANAGER"] },
//           ...(orgId
//             ? [{ name: "Manage Org's Users", path: '/home/addUser/list', icon: <MdManageAccounts style={{ fontSize: 14 }} />, allowed: ["ROLE_MANAGER",] },]
//             : []),
//           // { name: 'Dashboard', path: '/home/analytic-dashbaord', icon: <MdDashboardCustomize style={{ fontSize: 14 }} />, allowed: ["ROLE_MANAGER",] },
//         ],
//         Permissions: ["ROLE_MANAGER",]
//       },
//       {
//         title: 'Team Leads',
//         links: [
//           // { name: 'Dashboard', path: '/home/teamLeadDashboard/platform', icon: <MdOutlineDashboard style={{ fontSize: 14 }} />, allowed: ["ROLE_ADMIN", "ROLE_TEAM_LEAD"] },
//           // ...(orgId
//           //   ?
//           //   [{ name: 'Dashboard', path: '/home/teamLeadDashboard/client', icon: <MdOutlineDashboard style={{ fontSize: 14 }} />, allowed: ["ROLE_ADMIN", "ROLE_TEAM_LEAD"] },]
//           //   : []),
//           { name: 'Platform Allocation', path: '/home/teamLead/teamLeadAllocToTele', icon: <BsListNested style={{ fontSize: 14 }} />, allowed: ["ROLE_ADMIN", "ROLE_TEAM_LEAD"] },

//           { name: "Allocation", path: '/home/allocation/metadata', icon: <MdManageAccounts style={{ fontSize: 14 }} />, allowed: ["ROLE_TEAM_LEAD",] },
//           { name: "Campaigns", path: '/home/campaign/list', icon: <MdCampaign style={{ fontSize: 14 }} />, allowed: ["ROLE_TEAM_LEAD",] },
//           { name: 'Campaign Performance', path: '/home/campaign-Dashboard-stats', icon: <MdDashboardCustomize style={{ fontSize: 14 }} />, allowed: ["ROLE_TEAM_LEAD",] },
//           // { name: 'Client Allocation', path: '/home/client/teamLead/teamLeadAllocToTele', icon: <AiOutlineDatabase style={{ fontSize: 14 }} />, allowed: ["ROLE_ADMIN", "ROLE_TEAM_LEAD"] },
//           // { name: 'Platform Metadata', path: '/home/teamLeadAllocFileIdToTele', icon: <FaListOl style={{ fontSize: 14 }} />, allowed: ["ROLE_ADMIN", "ROLE_MANAGER", "ROLE_TEAM_LEAD"] },
//           // { name: 'Campaigns', path: '/home/campaign/list', icon: <MdCampaign style={{ fontSize: 14 }} />, allowed: ["ROLE_TEAM_LEAD"] },

//         ],
//         Permissions: ["ROLE_TEAM_LEAD",]
//       },
//       {
//         title: 'Tele Callers',
//         links: [
//           // { name: 'Your DashBoard', path: 'home/teleDashboard', icon: <MdOutlineDashboard style={{ fontSize: 14 }} />, allowed: [ "ROLE_TELE_CALLER"] },

//           { name: 'Platform Allocation', path: '/home/teleTdfUsers', icon: <FiUsers style={{ fontSize: 14 }} />, allowed: ["ROLE_TELE_CALLER"] },
//           { name: 'User Actions', path: '/home/userActions', icon: <MdOutlinePendingActions style={{ fontSize: 14 }} />, allowed: ["ROLE_TELE_CALLER"] },
//           { name: 'Allocations', path: '/home/teleCallers', icon: <AiOutlineDatabase style={{ fontSize: 14 }} />, allowed: ["ROLE_TELE_CALLER"] },
//           { name: 'Hot Leads', path: '/home/hotLeads', icon: <FaHotjar style={{ fontSize: 14 }} />, allowed: ["ROLE_TELE_CALLER"] },

//         ],
//         Permissions: ["ROLE_TELE_CALLER"]
//       },
//       // {
//       //   title: 'Marketing',
//       //   links: [
//       //     { name: 'Post Blog', path: '/home/createBlog', icon: <BsFillInfoCircleFill style={{ fontSize: 14 }} />, allowed: ["ROLE_DM"] },
//       //     { name: 'Blog List', path: '/home/blogList', icon: <IoMdListBox style={{ fontSize: 14 }} />, allowed: ["ROLE_DM"] },
//       //   ],
//       //   Permissions: ["ROLE_DM"]
//       // },
//       {
//         title: 'Campaigns',
//         links: [
//           { name: 'Campaigns', path: '/home/campaign/list', icon: <MdCampaign style={{ fontSize: 14 }} />, allowed: ["ROLE_CRM_ADMIN", "ROLE_DS"] },
//           { name: 'UTM', path: '/home/utm/records', icon: <MdMarkChatUnread style={{ fontSize: 14 }} />, allowed: ["ROLE_CRM_ADMIN", "ROLE_DS"] },

//         ],
//         Permissions: ["ROLE_DS"]
//       },
//     ]
//     let list = [];
//     for (let obj of links) {
//       // Check if any role in the role array matches any permission in the Permissions array
//       if (role.some(r => obj.Permissions.includes(r))) {
//         let innerList = [];
//         for (let key of obj.links) {
//           // Check if any role in the role array is allowed for the link
//           if (role.some(r => key.allowed.includes(r))) {
//             innerList.push(key);
//           }
//         }
//         let tempObj = obj;
//         tempObj.links = innerList;
//         list.push(tempObj);
//       }
//     }
//     if (
//       !email.includes("@theduefactory.com") || orgId
//     ) {
//       list = list.map(section => ({
//         ...section,
//         links: section.links.filter(link => !TDFPlatformLinks.includes(link.path))
//       })).filter(section => section.links.length > 0);
//     }
//     return list
//   }
//   const checkActivePath = (screen) => {
//     const str = pathname.split("/");
//     const path = screen.split("/")
//     if (
//       str[0] === path[0] &&
//       str[1] === path[1] &&
//       str[2] === path[2]) {
//       return true;
//     } else {
//       return false;
//     }

//   }
//   const checkActivePath3 = (screen) => {
//     const str = pathname.split("/");
//     const path = screen.split("/")
//     if (
//       str[0] === path[0] &&
//       str[1] === path[1] &&
//       str[2] === path[2] &&
//       str[3] === path[3]) {
//       return true;
//     } else {
//       return false;
//     }

//   }
//   const [openIndex, setOpenIndex] = useState(0);

//   const toggleAccordion = (index) => {
//     setOpenIndex(openIndex === index ? null : index);
//   };
//   const goToNav = (path) => {
//     navigate(path)
//   }

//   return (
//     <div className="accordion-container-main">
//       {CheckPermission().map((item, index) => (
//         <div key={index} className="accordion-list-item">
//           <div
//             className="accordion-list-item-header"
//             onClick={() => setOpenIndex(0)}
//           >
//             <h3 >{item.title}</h3>
//             {/* <FaChevronDown
//               className={`chevron-icon ${openIndex === index ? "open" : ""}`}
//               style={{ color: "black" }}
//             /> */}
//           </div>

//           {
//             // openIndex === index && 
//             (
//               <div className="accordion-list-item-content">
//                 <ul>
//                   {item.links.map((submenuItem, subIndex) => (
//                     <li
//                       key={subIndex}
//                       onClick={() => goToNav(submenuItem.path)}
//                       className={
//                         checkActivePath(submenuItem.path) ? "tree_label-active2" : "tree_label-inactive2"
//                       }
//                     >
//                       {submenuItem.icon}
//                       {submenuItem.name}
//                     </li>
//                   ))}
//                 </ul>
//               </div>
//             )}

//           {/* <div className="accordion-list-item-content">
//             <ul>
//               {item.links.map((submenuItem, subIndex) =>
//                 submenuItem.children ? <>

//                   <li
//                     key={subIndex}
//                     className={
//                       checkActivePath(submenuItem.path) ? "tree_label-active2" : "tree_label-inactive2"
//                     }
//                     onClick={() => toggleAccordion(subIndex)}
//                   >
//                     <div style={{
//                       display: 'flex', alignItems: "center", justifyContent: "space-between",
//                       width: "-webkit-fill-available", padding: "0px 10px 0px 0px"
//                     }}>
//                       <div
//                         style={{ display: 'flex', alignItems: "center", justifyContent: "space-between", gap: 5 }}
//                       >
//                         {submenuItem.icon}
//                         {submenuItem.name}
//                       </div>
//                       <FaChevronDown
//                         className={`chevron-icon ${openIndex === subIndex ? "open" : ""}`}
//                         style={{ color: "black" }}
//                       />
//                     </div>

//                   </li>
//                   {
//                     openIndex === subIndex && (
//                       <ul className='children-ul-class'>
//                         {
//                           submenuItem.children.map((child, childIndex) =>
//                           (<li
//                             key={childIndex}
//                             onClick={() => goToNav(child.path)}
//                             className={
//                               checkActivePath3(child.path) ? "tree_label-active3 children-li-class" : "tree_label-inactive3 children-li-class"
//                             }
//                           >
//                             {child.icon}
//                             {child.name}
//                           </li>)
//                           )
//                         }
//                       </ul>
//                     )
//                   }


//                 </> : <>
//                   <li
//                     key={subIndex}
//                     onClick={() => goToNav(submenuItem.path)}
//                     className={
//                       checkActivePath(submenuItem.path) ? "tree_label-active2" : "tree_label-inactive2"
//                     }
//                   >
//                     {submenuItem.icon}
//                     {submenuItem.name}
//                   </li>
//                 </>

//               )}
//             </ul>
//           </div> */}
//         </div>
//       ))}
//     </div>
//   );
// };



const AccordionMenu = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const match = pathname.match(/createOrganization\/([^/]+)/);
  const organizationId = match ? match[1] : null;

  // Separate state: which top-level section is open, and which submenu is open
  const [openSection, setOpenSection] = useState(null);
  const [openSubmenu, setOpenSubmenu] = useState(null);

  const getPermittedLinks = () => {
    const { role, email, orgId } = getLocalStorage("CURRENT_USER");

    const TDFPlatformLinks = [
      "/home/adminDashboard",
      "/home/processRecordPlatformAllocation/tdfAdminAllocToTl",
      "/home/teamLead/teamLeadAllocToTele",
      "/home/teleTdfUsers",
      "/home/userActions",
      "/home/campaignDashboard",
      "/home/teamLeadDashboard/platform",
    ];

    const links = [
      {
        title: "Super Admin",
        links: [
          {
            name: "Campaigns",
            path: "/home/campaign/list",
            icon: <MdCampaign />,
            allowed: ["ROLE_CRM_ADMIN"],
            children: [
              { name: "All Records", path: "/home/campaign/list", icon: <MdOutlineClearAll />, allowed: ["ROLE_CRM_ADMIN"] },
              // { name: "Templates", path: "/home/campaign/templates", icon: <MdOutlineCloudUpload />, allowed: ["ROLE_CRM_ADMIN"] },
            ],
          },
          { name: organizationId ? "Update Organization" : "Create Organization", path: "/home/createOrganization", icon: <GoOrganization />, allowed: ["ROLE_CRM_ADMIN"] },
          { name: "Organization List", path: "/home/organizationList", icon: <MdListAlt />, allowed: ["ROLE_CRM_ADMIN"] },
        ],
        Permissions: ["ROLE_CRM_ADMIN"],
      },
      {
        title: "Process Admin",
        links: [
          { name: "Platform Dashboard", path: "/home/adminDashboard", icon: <MdOutlineDashboard />, allowed: ["ROLE_ADMIN"] },
          { name: "Platform Allocation", path: "/home/processRecordPlatformAllocation/tdfAdminAllocToTl", icon: <FiUsers />, allowed: ["ROLE_ADMIN"] },
          { name: "Dashboard", path: "/home/analytic-dashbaord", icon: <MdDashboardCustomize />, allowed: ["ROLE_MANAGER", "ROLE_ADMIN"] },
          {
            name: "Allocation",
            path: "/home/allocation/metadata",
            icon: <MdManageAccounts />,
            allowed: ["ROLE_ADMIN"],
            children: [
              { name: 'Metadata', path: '/home/allocation/metadata', icon: <MdOutlineCallToAction />, allowed: ["ROLE_ADMIN", "ROLE_MANAGER", "ROLE_TEAM_LEAD"] },
              { name: 'All Records', path: '/home/allocation/all-records', icon: <MdOutlineClearAll />, allowed: ["ROLE_ADMIN", "ROLE_MANAGER", "ROLE_TEAM_LEAD"] },
              { name: 'Allocation Upload', path: '/home/allocation/file-process', icon: <MdOutlineCloudUpload />, allowed: ["ROLE_MANAGER"] },
            ]
          },

          {
            name: "Campaigns",
            path: "/home/campaign/list",
            icon: <MdCampaign />,
            allowed: ["ROLE_ADMIN"],
            children: [
              { name: "All Records", path: "/home/campaign/list", icon: <MdOutlineClearAll />, allowed: ["ROLE_CRM_ADMIN", "ROLE_ADMIN", "ROLE_DS", "ROLE_MANAGER", "ROLE_TEAM_LEAD"] },
              { name: "Templates", path: "/home/campaign/templates", icon: <MdOutlineCloudUpload />, allowed: ["ROLE_CRM_ADMIN", "ROLE_MANAGER", "ROLE_DS", "ROLE_ADMIN"] },
              { name: "Hot Leads", path: "/home/campaign/allLeads", icon: <FaHotjar />, allowed: ["ROLE_MANAGER", "ROLE_TEAM_LEAD"] },
            ],
          },
          { name: "Campaign Performance", path: "/home/campaign-Dashboard-stats", icon: <MdDashboardCustomize />, allowed: ["ROLE_ADMIN"] },
          { name: "Tele Performance", path: "/home/teleperformance/attempted", icon: <RiFilePaperFill />, allowed: ["ROLE_ADMIN"] },
          { name: "Campaign Dashboard", path: "/home/campaignDashboard", icon: <MdDashboardCustomize />, allowed: ["ROLE_ADMIN"] },
          ...(orgId ?
            [
              {
                name: "Manage Org's Users",
                path: "/home/addUser/list",
                icon: <MdManageAccounts />,
                allowed: ["ROLE_ADMIN"],
                children: [
                  { name: 'User List', path: '/home/addUser/list', icon: <CgUserList />, allowed: ["ROLE_ADMIN", "ROLE_MANAGER"] },
                  { name: 'Create User', path: '/home/addUser/createUser', icon: <FaUserPlus />, allowed: ["ROLE_ADMIN", "ROLE_MANAGER"] },
                ]
              }] : []),
        ],
        Permissions: ["ROLE_ADMIN"],
      },
      {
        title: "Process Manager",
        links: [
          { name: "Platform Dashboard", path: "/home/adminDashboard", icon: <MdOutlineDashboard />, allowed: ["ROLE_MANAGER"] },
          { name: "Platform Allocation", path: "/home/processRecordPlatformAllocation/tdfAdminAllocToTl", icon: <FiUsers />, allowed: ["ROLE_MANAGER"] },
          { name: "Dashboard", path: "/home/analytic-dashbaord", icon: <MdDashboardCustomize />, allowed: ["ROLE_MANAGER"] },
          {
            name: "Allocation",
            path: "/home/allocation/metadata",
            icon: <MdManageAccounts />,
            allowed: ["ROLE_MANAGER"],
            children: [
              { name: 'Metadata', path: '/home/allocation/metadata', icon: <MdOutlineCallToAction />, allowed: ["ROLE_ADMIN", "ROLE_MANAGER", "ROLE_TEAM_LEAD"] },
              { name: 'All Records', path: '/home/allocation/all-records', icon: <MdOutlineClearAll />, allowed: ["ROLE_ADMIN", "ROLE_MANAGER", "ROLE_TEAM_LEAD"] },
              { name: 'Allocation Upload', path: '/home/allocation/file-process', icon: <MdOutlineCloudUpload />, allowed: ["ROLE_MANAGER"] },
            ]
          },
          {
            name: "Campaigns",
            path: "/home/campaign/list",
            icon: <MdCampaign />,
            allowed: ["ROLE_MANAGER"],
            children: [
              { name: "All Records", path: "/home/campaign/list", icon: <MdOutlineClearAll />, allowed: ["ROLE_CRM_ADMIN", "ROLE_ADMIN", "ROLE_DS", "ROLE_MANAGER", "ROLE_TEAM_LEAD"] },
              { name: "Templates", path: "/home/campaign/templates", icon: <MdOutlineCloudUpload />, allowed: ["ROLE_CRM_ADMIN", "ROLE_MANAGER", "ROLE_DS", "ROLE_ADMIN"] },
              { name: "Hot Leads", path: "/home/campaign/allLeads", icon: <FaHotjar />, allowed: ["ROLE_MANAGER", "ROLE_TEAM_LEAD"] },
            ],
          },
          { name: "Campaign Dashboard", path: "/home/campaignDashboard", icon: <MdDashboardCustomize />, allowed: ["ROLE_MANAGER"] },
          { name: "Tele Performance", path: "/home/teleperformance/attempted", icon: <RiFilePaperFill />, allowed: ["ROLE_MANAGER"] },
          { name: "Campaign Performance", path: "/home/campaign-Dashboard-stats", icon: <MdDashboardCustomize />, allowed: ["ROLE_MANAGER"] },
          ...(orgId ?
            [
              {
                name: "Manage Org's Users",
                path: "/home/addUser/list",
                icon: <MdManageAccounts />,
                allowed: ["ROLE_MANAGER"],
                children: [
                  { name: 'User List', path: '/home/addUser/list', icon: <CgUserList />, allowed: ["ROLE_ADMIN", "ROLE_MANAGER"] },
                  { name: 'Create User', path: '/home/addUser/createUser', icon: <FaUserPlus />, allowed: ["ROLE_ADMIN", "ROLE_MANAGER"] },
                ]
              }]
            :
            []),
        ],
        Permissions: ["ROLE_MANAGER"],
      },
      {
        title: "Team Leads",
        links: [
          { name: "Platform Allocation", path: "/home/teamLead/teamLeadAllocToTele", icon: <BsListNested />, allowed: ["ROLE_ADMIN", "ROLE_TEAM_LEAD"] },
          {
            name: "Allocation",
            path: "/home/allocation/metadata",
            icon: <MdManageAccounts />,
            allowed: ["ROLE_TEAM_LEAD"],
            children: [
              { name: 'Metadata', path: '/home/allocation/metadata', icon: <MdOutlineCallToAction />, allowed: ["ROLE_TEAM_LEAD"] },
              { name: 'All Records', path: '/home/allocation/all-records', icon: <MdOutlineClearAll />, allowed: ["ROLE_TEAM_LEAD"] },
            ]
          },
          {
            name: "Campaigns",
            path: "/home/campaign/list",
            icon: <MdCampaign />,
            allowed: ["ROLE_TEAM_LEAD"],
            children: [
              { name: "All Records", path: "/home/campaign/list", icon: <MdOutlineClearAll />, allowed: ["ROLE_TEAM_LEAD"] },
              { name: "Hot Leads", path: "/home/campaign/allLeads", icon: <FaHotjar />, allowed: ["ROLE_TEAM_LEAD"] },
            ],
          },
          { name: "Campaign Performance", path: "/home/campaign-Dashboard-stats", icon: <MdDashboardCustomize />, allowed: ["ROLE_TEAM_LEAD"] },
        ],
        Permissions: ["ROLE_TEAM_LEAD"],
      },
      {
        title: "Tele Callers",
        links: [
          { name: "Platform Allocation", path: "/home/teleTdfUsers", icon: <FiUsers />, allowed: ["ROLE_TELE_CALLER"] },
          { name: "User Actions", path: "/home/userActions", icon: <MdOutlinePendingActions />, allowed: ["ROLE_TELE_CALLER"] },
          { name: "Allocations", path: "/home/teleCallers", icon: <AiOutlineDatabase />, allowed: ["ROLE_TELE_CALLER"] },
          { name: "Hot Leads", path: "/home/hotLeads", icon: <FaHotjar />, allowed: ["ROLE_TELE_CALLER"] },
        ],
        Permissions: ["ROLE_TELE_CALLER"],
      },
      {
        title: "Campaigns",
        links: [
          { name: "Campaigns", path: "/home/campaign/list", icon: <MdCampaign />, allowed: ["ROLE_CRM_ADMIN", "ROLE_DS"] },
          { name: "UTM", path: "/home/utm/records", icon: <MdMarkChatUnread />, allowed: ["ROLE_CRM_ADMIN", "ROLE_DS"] },
        ],
        Permissions: ["ROLE_DS"],
      },
    ];

    let list = [];
    for (let obj of links) {
      if (role.some((r) => obj.Permissions.includes(r))) {
        // const innerList = obj.links.filter((link) => role.some((r) => link.allowed.includes(r)));
        const innerList = obj.links
          .filter(
            (link) =>
              role.some((r) => link.allowed.includes(r))
          )
          .map((link) => ({
            ...link,
            children: link.children
              ? link.children.filter((child) =>
                role.some((r) =>
                  child.allowed.includes(r)
                )
              )
              : undefined,
          }))
          .filter(
            (link) =>
              !link.children ||
              link.children.length > 0
          );
        if (innerList.length > 0) {
          list.push({ ...obj, links: innerList });
        }
      }
    }

    if (!email.includes("@theduefactory.com") || orgId) {
      list = list
        .map((section) => ({
          ...section,
          links: section.links.filter((link) => !TDFPlatformLinks.includes(link.path)),
        }))
        .filter((section) => section.links.length > 0);
    }

    return list;
  };

  const permittedLinks = getPermittedLinks();

  // Auto-open the section containing the active path on mount
  useEffect(() => {
    permittedLinks.forEach((section, sectionIndex) => {
      const hasActive = section.links.some((link) => {
        if (isActivePath(link.path)) return true;
        if (link.children) return link.children.some((child) => isActivePath3(child.path));
        return false;
      });
      if (hasActive) {
        setOpenSection(sectionIndex);
        // Also open the submenu if a child is active
        section.links.forEach((link, linkIndex) => {
          if (link.children && link.children.some((child) => isActivePath3(child.path))) {
            setOpenSubmenu(`${sectionIndex}-${linkIndex}`);
          }
        });
      }
    });
  }, [pathname]);

  const isActivePath = (screen) => {
    const str = pathname.split("/");
    const path = screen.split("/");
    return str[0] === path[0] && str[1] === path[1] && str[2] === path[2];
  };

  const isActivePath3 = (screen) => {
    const str = pathname.split("/");
    const path = screen.split("/");
    return str[0] === path[0] && str[1] === path[1] && str[2] === path[2] && str[3] === path[3];
  };

  const toggleSection = (index) => {
    setOpenSection((prev) => (prev === index ? null : index));
    // Close any open submenu when switching sections
    setOpenSubmenu(null);
  };

  const toggleSubmenu = (e, key) => {
    e.stopPropagation(); // prevent nav on parent click
    setOpenSubmenu((prev) => (prev === key ? null : key));
  };

  return (
    <div className="accordion-container-main">
      {permittedLinks.map((section, sectionIndex) => {
        const isSectionOpen = openSection === sectionIndex;
        return (
          <div key={sectionIndex} className="accordion-section">
            <div
              className={`accordion-section-header ${isSectionOpen ? "is-open" : ""}`}
            // onClick={() => toggleSection(sectionIndex)}
            >
              <span className="accordion-section-title">{section.title}</span>
              {/* <FaChevronDown className={`accordion-chevron ${isSectionOpen ? "rotated" : ""}`} /> */}
            </div>

            <div className={`accordion-section-body ${isSectionOpen ? "is-open" : ""}`}>
              <ul className="accordion-nav-list">
                {section.links.map((link, linkIndex) => {
                  const submenuKey = `${sectionIndex}-${linkIndex}`;
                  const isSubmenuOpen = openSubmenu === submenuKey;

                  if (link.children) {
                    return (
                      <div key={linkIndex}>
                        <li
                          className={`accordion-nav-item has-children ${isActivePath(link.path) ? "is-active" : ""}`}
                          onClick={(e) => {
                            toggleSubmenu(e, submenuKey)
                            navigate(link.path)
                          }
                          }
                        >
                          <span className="nav-item-icon">{link.icon}</span>
                          <span className="nav-item-label">{link.name}</span>
                          <FaChevronDown className={`submenu-chevron ${isSubmenuOpen ? "rotated" : ""}`} />
                        </li>
                        <ul className={`accordion-children-list ${isSubmenuOpen ? "is-open" : ""}`}>
                          {link.children.map((child, childIndex) => (
                            <li
                              key={childIndex}
                              className={`accordion-child-item ${isActivePath3(child.path) ? "is-active" : ""}`}
                              onClick={() => navigate(child.path)}
                            >
                              <span className="nav-item-icon">{child.icon}</span>
                              <span className="nav-item-label">{child.name}</span>
                            </li>
                          ))}
                        </ul>
                      </div>
                    );
                  }

                  return (
                    <li
                      key={linkIndex}
                      className={`accordion-nav-item ${isActivePath(link.path) ? "is-active" : ""}`}
                      onClick={(e) => {
                        navigate(link.path)
                        toggleSubmenu(e, null)
                      }}
                    >
                      <span className="nav-item-icon">{link.icon}</span>
                      <span className="nav-item-label">{link.name}</span>
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        );
      })}
    </div>
  );
};

const Sidebar = () => {
  const { activeMenu, screenSize, } = useStateContext();
  const [isOpen, setIsOpen] = useState(false);
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [menuToggle, setMenuToggle] = useState(false);
  const token = getLocalStorage("access_token");
  const openMenu = () => {
    setMenuToggle(!menuToggle);
  };


  useEffect(() => {
    if (activeMenu) {
      gsap.to("#mytext", {
        duration: 0.5,
        opacity: 1,
        x: 0,
        stagger: 0.1,
        ease: 'power1.out',
      });
    } else {
      gsap.to("#mytext", {
        duration: 0.5,
        opacity: 0,
        x: -50,
        stagger: 0.1,
        ease: 'power1.in',
      });
    }
  }, [activeMenu]);


  const currentUser = getLocalStorage("CURRENT_USER");
  const { name, role, processName } = currentUser;
  const handleNavigate = (path) => {
    navigate(path)
    setMenuToggle(false)
  }
  const handleLogout = () => {
    localStorage.clear();
    stopTokenRefreshWebSocket();
    // 3. Redirect to login
    window.location.href = "/login";
  }
  const handleSetting = (e) => {
    setIsOpen(!isOpen)
  };
  useEffect(() => {
    setIsOpen(false);
  }, [pathname]);

  const handleMyProfile = () => {
    navigate("/home/myProfile")
    setIsOpen(!isOpen)
  };
  const handleMyOrganization = () => {
    navigate("/home/myOrganization")
    setIsOpen(!isOpen)
  }
  const { orgId } = getLocalStorage("CURRENT_USER");


  return (<>
    {screenSize >= 1000 ?
      <div className='side-menu-main'>
        <div className='side-bar-main-head'>
          <img style={{ height: 30, width: activeMenu ? 140 : 0, marginLeft: 5 }} src={logo} alt="logo" />
        </div>
        <div className='side-bar-body'>
          <AccordionMenu />
        </div>
        <div className="side-bar-footer">
          <div className='side-bar-footer-elm'>
            <div className='side-bar-footer-elm-1'>
              <img src={SidebarPoster} alt='sidebar-poster' />
              <div className='side-bar-footer-elm-1-1'>
                <p>{processName}</p>
                <span>{name}</span>
              </div>
            </div>
            <button style={{ fontSize: 18, cursor: "pointer" }} title='setting' onClick={(e) => handleSetting(e)}>
              <IoSettingsOutline style={{ cursor: "pointer" }} />
            </button>
          </div>
        </div>
      </div>

      : <>
        <div className='menu-bar-main'>
          <div className='menu-bar-main-head'>
            <img style={{ height: 30, width: 140, marginLeft: 5 }} src={logo} alt="logo" />
          </div>
          <button onClick={openMenu}>
            <div className="">
              <div
                className={`hamburger ${menuToggle ? 'is-active' : ''}`}
                id="hamburger-9"
              >
                <span className="line"></span>
                <span className="line"></span>
                <span className="line"></span>
              </div>
            </div>
          </button>
          <div style={{ display: menuToggle ? "block" : "none" }} className='floating-menu-options'>

            <div className='side-menu-main'>
              <div className='side-bar-main-head'>
                <img style={{ height: 30 }} src={logo} alt="logo" />
              </div>
              <div className='side-bar-body'>
                <AccordionMenu />
              </div>
              <div className="side-bar-footer">
                {/* <img src={SidebarPoster} alt='sidebar-poster' />
                <div className='side-bar-footer-box'>
                  <p>{name}</p>
                  <button style={{ fontSize: 14 }} title='logout' onClick={handleLogout}> <BiLogOutCircle /></button>
                  <button style={{ fontSize: 14 }} title='setting' onClick={(e) => handleSetting(e)}>
                    <IoSettingsOutline />
                  </button>
                </div> */}
                <div className='side-bar-footer-elm'>
                  <div className='side-bar-footer-elm-1'>
                    <img src={SidebarPoster} alt='sidebar-poster' />
                    <div className='side-bar-footer-elm-1-1'>
                      <p>{processName}</p>
                      <span>{name}</span>
                    </div>
                  </div>
                  <button style={{ fontSize: 18, cursor: "pointer" }} title='setting' onClick={(e) => handleSetting(e)}>
                    <IoSettingsOutline style={{ cursor: "pointer" }} />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>}
    {/* Popover should always be rendered */}
    <div style={{ display: isOpen ? "flex" : "none" }} className='pop-over-buttons'>
      <button onClick={handleMyProfile}><CgProfile /> My Profile</button>
      {(role[0] === "ROLE_ADMIN" && orgId) ? (<>
        <button onClick={handleMyOrganization}><GoOrganization /> My Organization</button>
      </>) : (<></>)}
      <button onClick={handleLogout}><BiLogOutCircle /> Logout</button>
    </div>

  </>)
};

export default Sidebar;